
import { defineComponent, ref, onBeforeMount } from "vue";
import { hideModal } from "@/core/helpers/dom";
import { ApiTaskManagement, ApiBase } from "@/core/api";
import mixin from "@/mixins";
import _ from "lodash";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "add-recommendation-modal",
  components: {},
  emits: ["update-list"],
  setup(props, { emit }) {
    const loading = ref<boolean>(false);
    const formRef = ref<null | HTMLFormElement>(null);
    const addStandardOperatingProcedureModalRef = ref<null | HTMLElement>(null);
    const submitButton = ref<HTMLElement | null>(null);

    const { t } = useI18n();

    const {
      showValidateErrorMsg,
      showFormSubmitSuccessMsg,
      showServerErrorMsg,
    } = mixin();

    const formData = ref({
      system_status: 10,
      subject: "",
      type: "",
      apply_to: [],
    });

    const rules = ref({
      subject: [
        {
          required: true,
          message: t("common.isRequired"),
          trigger: "change",
        },
      ],
      type: [
        {
          required: true,
          message: t("common.isRequired"),
          trigger: "change",
        },
      ],
      apply_to: [
        {
          required: true,
          // asyncValidator: (rule, value) => {
          //   return new Promise<void>((resolve, reject) => {
          //     if (formData.value.type != "1") {
          //       reject(t("common.isRequired"));
          //     } else {
          //       resolve();
          //     }
          //   });
          // },
          message: t("common.isRequired"),
          trigger: "change",
        },
      ],
    });

    const subjectOptions = ref([]);
    const subjectLoading = ref<boolean>(false);
    const typeOptions = ref([
      // { label: "Account Validation", value: "1" },
      // { label: "Call-Out", value: "2" },
      // { label: "Quick Inquiry", value: "3" },
    ]);
    const typeLoading = ref<boolean>(false);
    const ouickInquiryApplyToOptions = ref([]);
    const callOutApplyToOptions = ref([]);
    const applyToLoading = ref<boolean>(false);

    const getDropdownOptions = async () => {
      const { data } = await ApiBase.getTaggingData({
        short_key: [
          "call_out_subject",
          "quick_inquiry_comment_tagging",
          // "sop_apply_to",
          "distribution_task_type",
        ],
      });
      if (data.code == 0) {
        subjectOptions.value = data.data.call_out_subject.items;
        callOutApplyToOptions.value =
          data.data.quick_inquiry_comment_tagging.items;
        ouickInquiryApplyToOptions.value = data.data.call_out_subject.items;
        typeOptions.value = data.data.distribution_task_type.items;
      }
    };

    const typeChange = () => {
      formData.value.apply_to = [];
    };

    const submit = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate((valid) => {
        if (valid) {
          loading.value = true;
          if (submitButton.value) {
            submitButton.value.setAttribute("data-kt-indicator", "on");
          }
          ApiTaskManagement.addStandardOperatingProcedure(formData.value)
            .then(({ data }) => {
              loading.value = false;
              submitButton.value?.removeAttribute("data-kt-indicator");
              if (data.code == 0) {
                showFormSubmitSuccessMsg(() => {
                  resetForm();
                  hideModal(addStandardOperatingProcedureModalRef.value);
                  emit("update-list");
                });
              } else {
                showServerErrorMsg(data);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          showValidateErrorMsg();
          return false;
        }
      });
    };

    const handleDiscard = () => {
      hideModal(addStandardOperatingProcedureModalRef.value);
      resetForm();
    };

    const resetForm = () => {
      formRef.value?.resetFields();
    };

    onBeforeMount(() => {
      getDropdownOptions();
    });

    return {
      loading,
      formData,
      rules,
      formRef,
      addStandardOperatingProcedureModalRef,
      submitButton,
      subjectOptions,
      subjectLoading,
      typeOptions,
      typeLoading,
      ouickInquiryApplyToOptions,
      callOutApplyToOptions,
      applyToLoading,
      t,
      typeChange,
      submit,
      handleDiscard,
      resetForm,
    };
  },
});
